import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const env = (typeof import.meta !== 'undefined' && import.meta.env) || {}

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || 'dummy-api-key-for-tests',
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || 'cs-sheets-training.firebaseapp.com',
  projectId: env.VITE_FIREBASE_PROJECT_ID || 'cs-sheets-training',
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || 'cs-sheets-training.appspot.com',
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || '000000000000',
  appId: env.VITE_FIREBASE_APP_ID || '1:000000000000:web:000000000000',
}

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const googleProvider = new GoogleAuthProvider()

// Hint Google login to show finder.com accounts (users with findercrew.com
// accounts can still sign in — the hd param is a UI hint, not a hard block;
// actual enforcement happens in AuthContext)
googleProvider.setCustomParameters({
  hd: 'finder.com',
})

// All Firestore data for this app lives under this root path
// All Firestore data for this app lives under apps (collection) / cs-sheets-training (doc)
export const APP_COLLECTION = 'apps'
export const APP_DOC = 'cs-sheets-training'
